
import { computed, defineComponent, reactive } from 'vue'
import SubscriptionPlans from '@/components/subscription/SubscriptionPlans.vue'
import { store } from '@/store'
import { redirectTomanageSubscription } from '@/api/tripply'

export default defineComponent({
  name: 'UserAccount',
  components: { SubscriptionPlans },
  setup() {
    const state = reactive({
      managing: false
    })
    const userState = store.user.get(state => state)

    function signOut() {
      store.auth.signOut()
    }

    async function manage() {
      state.managing = true
      await redirectTomanageSubscription()
    }

    return { state, userState, signOut, manage }
  }
})
